export default __webpack_public_path__ + "static/media/Parallax-HUD-Heading.84437cb2.jpg";